/* unplugin-vue-components disabled */import script from "./CommoditiesView.vue?vue&type=script&setup=true&lang=js"
export * from "./CommoditiesView.vue?vue&type=script&setup=true&lang=js"

import "./CommoditiesView.vue?vue&type=style&index=0&id=b0493c02&lang=css"
import "./CommoditiesView.vue?vue&type=style&index=1&id=b0493c02&lang=less&scoped=true"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/e652ddcf-2c47-4325-b31c-639f40aeccc9/workspace/mobile-FTZCOIN_ILBL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0493c02"]])

export default __exports__